var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpticians = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Glasses-Retro--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Glasses Retro Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.61 1.43a1 1 0 0 0 0 2A1.4 1.4 0 0 1 22 4.83v7.43a0.25 0.25 0 0 1 -0.13 0.22 0.24 0.24 0 0 1 -0.26 0A5.55 5.55 0 0 0 13.84 14a0.52 0.52 0 0 1 -0.63 0.18 2.85 2.85 0 0 0 -2.42 0 0.52 0.52 0 0 1 -0.63 -0.18 5.55 5.55 0 0 0 -7.77 -1.5 0.24 0.24 0 0 1 -0.26 0 0.25 0.25 0 0 1 -0.13 -0.24V4.83a1.4 1.4 0 0 1 1.39 -1.4 1 1 0 0 0 0 -2A3.4 3.4 0 0 0 0 4.83V17a5.55 5.55 0 1 0 11.09 0v-0.24a0.91 0.91 0 0 1 1.82 0V17A5.55 5.55 0 1 0 24 17V4.83a3.4 3.4 0 0 0 -3.39 -3.4ZM5.54 20.57A3.55 3.55 0 1 1 9.09 17a3.55 3.55 0 0 1 -3.55 3.57Zm12.92 0A3.55 3.55 0 1 1 22 17a3.55 3.55 0 0 1 -3.54 3.57Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpticians);
export default ForwardRef;